import {environmentConfig} from "@/config/enviromentConfig";

const DEFAULT_MTN_HEADER_ENRICHMENT_URL = 'http://mtn.penroseza.com/';
const HEADER_ENRICHMENT_GAME = 'wp-rugby-zone';

export default class HeaderEnrichmentService {
    static getMtnHeaderEnrichmentUrl(urlParams = new URLSearchParams(window.location.search)) {
        const configuredUrl = environmentConfig.mtnHeaderEnrichmentUrl;
        const headerEnrichmentBaseUrl = configuredUrl && configuredUrl !== 'undefined'
            ? configuredUrl
            : DEFAULT_MTN_HEADER_ENRICHMENT_URL;

        const redirectUrl = new URL(headerEnrichmentBaseUrl);
        redirectUrl.searchParams.set('game', HEADER_ENRICHMENT_GAME);

        return redirectUrl.toString();
    }

    static redirectToMtnHeaderEnrichment(urlParams = new URLSearchParams(window.location.search)) {
        const redirectUrl = HeaderEnrichmentService.getMtnHeaderEnrichmentUrl(urlParams);
        window.open(redirectUrl, '_self');
        return redirectUrl;
    }
}
